import { useMemo } from 'react';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { courseHasPendingTranslation, TRANSLATION_POLL_INTERVAL_MS } from './coverageStatus';
import { summariseCoverage, type TranslationsToolbarSummary } from './translationsSummary';

// Reads the same listByCourse cache as the units-list badge and coverage page,
// so all three agree and dedupe to one poll. (Single-resource surfaces use
// useContentTranslations.)
export function useCourseTranslations(courseId: string): TranslationsToolbarSummary {
  const query = trpcAdmin.contentTranslations.listByCourse.useQuery(
    { courseId },
    {
      refetchInterval: (query) =>
        courseHasPendingTranslation(query.state.data?.units) || query.state.status === 'error'
          ? TRANSLATION_POLL_INTERVAL_MS
          : false,
      refetchIntervalInBackground: true,
    },
  );

  const summary = useMemo(
    () =>
      summariseCoverage(
        query.data?.units ?? [],
        query.data?.supportedLanguages ?? [],
        query.isError,
      ),
    [query.data, query.isError],
  );

  const isActive = (query.data?.supportedLanguages.length ?? 0) > 0;

  return { ...summary, isLoading: query.isLoading, isError: query.isError, isActive };
}
